import type {Pointer} from '@wix/document-services-types'
import type {SerializedVariablesList} from '../types'
import {DATA_TYPES} from '../../../constants/constants'
import type {VariantsAPI} from '../../variants/variants'

export interface IVariableRepository {
    getRawVariablesData(): SerializedVariablesList | undefined
}

export class VariableRepository implements IVariableRepository {
    constructor(private readonly variantsAPI: VariantsAPI, private readonly rootWidget: Pointer) {}

    getRawVariablesData(): SerializedVariablesList | undefined {
        return this.variantsAPI.getItemConsideringVariantsForPointer(this.rootWidget, DATA_TYPES.variables)
    }
}
